module.exports = __webpack_public_path__ + "img/post-austria-cod.e648ea20.png";